module.exports = __webpack_public_path__ + "img/change.5d34a3d1.png";